import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setUser, removeUser } from '../../actions';
import withBackend from '../../backend/withBackend';
import SettingsPage from '../../components/SettingsPage';

class SettingsPageContainer extends Component {
  render() {
    const { firebase, setUser, removeUser } = this.props;
    return (
      <SettingsPage
        firebase={firebase}
        setUser={setUser}
        onRemoveUser={removeUser}
      />
    );
  }
}

export default compose(
  connect(null, { setUser, removeUser }),
  withBackend
)(SettingsPageContainer);
